/**
 * sl-728o.3.1: Smart Lookup Session
 */
import type { useI18n } from '@affine/i18n';

import type { TutorialSession } from '../../types';

type I18n = ReturnType<typeof useI18n>;

export function createSmartLookupSession(t: I18n): TutorialSession {
  return {
    id: 'automation:smartLookup',
    context: {
      targetAudience: 'technical',
      category: 'automation',
      tab: 'output',
    },
    steps: [
      {
        targetSelector: '[data-coachmark-target="relation-lookup-toggle"]',
        title: t['com.streamlain.streamlain.coach.smart-lookup.title'](),
        content: t['com.streamlain.streamlain.coach.smart-lookup.content'](),
        animation: 'pulse',
      },
    ],
  };
}
